/**
 * Dispatch Request Headers
 * 
 * @type       {Array}
 */
export default [
  {
    text: '#',
    value: 'id',
    sortable: true,
  },
  {
    text: 'responsable',
    value: 'g_seller_user_full_name',
  },
  {
    text: 'rut',
    value: 'sl_customer_rut',
    format: 'rut',
  },
  {
    text: 'cliente',
    value: 'sl_customer_alias_name',
  },
  {
    text: 'estado',
    value: 'g_state_name',
    align: 'center',
    component: {
      type: 'chip-label',
      props: {
        palette: {
          anulado_en_inventario: 'grey darken-4 white--text',
          anulado_desde_venta: 'grey darken-4 white--text',
          en_armado: 'accent lighten-1',
          en_lote_de_despacho: 'secondary lighten-1',
          confirmada: 'secondary lighten-3',
          despachada: 'info lighten-3',
          no_recepcionada: 'error lighten-3',
          por_despachar: 'accent lighten-3',
          recepcionada: 'success lighten-3',
          recepcionada_parcialmente: 'success lighten-3',
        },
        small: true,
      },
    },
    sortable: 'g_state_id',
  },
  {
    text: 'comuna',
    value: 'sl_customer_branch_offices_g_commune_name',
  },
  /*{
    text: 'lote',
    value: 'batch_id',
    align: 'right',
    component: {
      type: 'link',
      props: {
        mapper: value => ({
          name: 'dispatch-request-batch-update',
            params: {
              id: value,
            },
          }),
        tooltip: 'Detalle del lote',
      },
    },
  },*/  
  {
    text: 'creación',
    value: 'created_at',
    sortable: true,
    align: 'right',
    format: 'datetime-detail',
  },
]
